import { render, staticRenderFns } from "./delatnosti.editor.vue?vue&type=template&id=641dd179&scoped=true&"
import script from "./delatnosti.editor.vue?vue&type=script&lang=ts&"
export * from "./delatnosti.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641dd179",
  null
  
)

export default component.exports